import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { I18nProvider } from "./i18n/index.tsx";
import "./styles/tokens.css";
import "./styles/informationsraster.css";
import "./styles/zustandsformen.css";

const root = document.getElementById("root");
if (!root) throw new Error("Wurzelelement #root fehlt.");
createRoot(root).render(
  <StrictMode>
    {/* Die Sprache umschliesst die gesamte Anwendung -- Anmeldeseite wie
        Arbeitsoberflaeche. Beide verwenden dieselbe Auswahl. */}
    <I18nProvider><App /></I18nProvider>
  </StrictMode>,
);
